export default "__VITE_ASSET__CqRsBOKR__"